import { call, put, takeLatest } from 'redux-saga/effects'

import {
  getUsers,
  showUser,
  deactivateUser,
  updateUser,
  inviteUser,
  getCareManagers,
  setPassword,
  deleteUser,
} from './index.reducer'

import {updateMe} from '../auth/Login/index.reducer'
import Api from '../services/ApiCaller'
import { showMessage } from '../utils'
import {translate} from '../i18n'
import { goBack } from 'connected-react-router'

export function* getUsersRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getUsers.success(res))
    } else {
      yield put(getUsers.failure(message))
    }
  } catch (e) {
    yield put(getUsers.failure(e.message))
  }
}
function* getUserByIdRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(showUser.success(res))
    } else {
      yield put(showUser.failure(message))
    }
  } catch (e) {
    yield put(showUser.failure(e.message))
  }
}

export function* UpdateUserRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(updateUser.success(res))
      showMessage(`${translate('users.messages.successfulUpdate')}`)
      yield put(goBack())
      yield(put(updateMe.success(res)))

    } else {
      yield put(updateUser.failure(message))
    }
  } catch (e) {
    yield put(updateUser.failure(e.message))
  }
}

export function* deleteUserRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(deleteUser.success(res))
      showMessage(`${translate('users.messages.successfulRemove')}`)
      yield put(goBack())
    } else {
      yield put(deleteUser.failure(message))
    }
  } catch (e) {
    yield put(deleteUser.failure(e.message))
  }
}

export function* InviteUserRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(inviteUser.success(res))
      //yield put(goBack())
    } else {
      yield put(inviteUser.failure(message))
    }
  } catch (e) {
    yield put(inviteUser.failure(e.message))
  }
}

export function* setPasswordRequest(api: any, { payload }: any) {
  try {
    //   const { res = {} } = yield call(Api.callServer, api, payload);
    //   const { data, success, message } = res;
    if (true) {
      yield put(setPassword.success({}))
    } else {
      yield put(setPassword.failure(''))
    }
  } catch (e) {
    yield put(setPassword.failure())
  }
}

export function* DeactivateUserRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { data, success, message } = res
    if (success && data) {
      yield put(deactivateUser.success(data))
    } else {
      yield put(deactivateUser.failure(message))
    }
  } catch (e) {
    yield put(deactivateUser.failure())
  }
}
export function* getCareMagersRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (!error) {
      yield put(getCareManagers.success(res))
    } else {
      yield put(getCareManagers.failure(message))
    }
  } catch (e) {
    yield put(getCareManagers.failure(e.message))
  }
}

export default (api: any) => {
  const getUsersApi = (data: any) => api.get('/users', data)
  const getUsersByIdApi = (data: any) => api.get(`/users/${data.id}`)
  const updateUserApi = (data: any) => api.put(`/users/${data.id}`, data.data)
  const deleteUserApi = (data: any) => api.delete(`/users/${data.id}`)
  const inviteUserApi = (data: any) => api.post(`/users`, data)
  const getCareManagersApi = (data:any)=> api.get(`/users?careManagers=true`, data)
  const setPasswordApi = (data: any) =>
    api.post('/users/forgot-password', data)
  const deactivateUserApi = (data: any) =>
    api.patch(`/users/${data.id}/deactivate`)

  return [
    takeLatest(getUsers.TRIGGER, getUsersRequest, getUsersApi),
    takeLatest(showUser.TRIGGER, getUserByIdRequest, getUsersByIdApi),
    takeLatest(updateUser.TRIGGER, UpdateUserRequest, updateUserApi),
    takeLatest(deleteUser.TRIGGER, deleteUserRequest, deleteUserApi),
    takeLatest(inviteUser.TRIGGER, InviteUserRequest, inviteUserApi),
    takeLatest(setPassword.TRIGGER, setPasswordRequest, setPasswordApi),
    takeLatest(deactivateUser.TRIGGER, DeactivateUserRequest, deactivateUserApi),
    takeLatest(getCareManagers.TRIGGER, getCareMagersRequest, getCareManagersApi)
  ]
}
